<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{ name: 'Users' }">
              <h4 class="ms-2">
                {{ label.pages.users }}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
              @click="$router.go(-1)"
              v-b-tooltip.hover.right
              :title="label.pages.previousPage"
              class="mouse-change pe-3"
            >
              <b-icon
                icon="arrow-left-square-fill"
                variant="ps-base"
                scale="1.2"
                class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
            :show-row-lines="true"
            :show-column-lines="true"
            :show-borders="true"
            :row-alternation-enabled="true"
            :rtl-enabled="label.direction === 'rtl' ? true : false"
            :data-source="items"
            :columns="fields"
            :column-auto-width="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            column-resizing-mode="widget"
            :hover-state-enabled="true"
            :noDataText="checkData"
            @toolbar-preparing="onToolbarPreparing($event)"
            key-expr="id"
            class="ps_Table"
            :height="dataGridHeight"
          >
            <DxSearchPanel
              :visible="true"
              :width="240"
              :placeholder="label.pages.search"
            />
            <DxColumnChooser :enabled="true" mode="dragAndDrop" />
            <DxExport :enabled="true" />
            <template #btnRGroup>
              <b-row>
                <b-col cols="5">
                  <date-picker
                    class="p-datePicker-leave"
                    color="#6b53ad"
                    input-class="p-datePicker-input-leave"
                    :auto-submit="true"
                    v-model="fromDateLocal"
                    :clearable="true"
                  >
                    <div slot="label">
                      <span style="font-size: 9pt"
                        >{{ label.pages.fromDate }}
                      </span>
                    </div>
                  </date-picker>
                </b-col>
                <b-col cols="5">
                  <date-picker
                    class="p-datePicker-leave"
                    color="#6b53ad"
                    input-class="p-datePicker-input-leave"
                    :auto-submit="true"
                    v-model="toDateLocal"
                    :clearable="true"
                  >
                    <div slot="label">
                      <span style="font-size: 9pt">{{
                        label.pages.toDate
                      }}</span>
                    </div>
                  </date-picker>
                </b-col>
                <b-col cols="2">
                  <b-button
                    variant="ps-second"
                    class="py-1"
                    size="sm"
                    v-b-tooltip.hover
                    @click="reloadData"
                    :title="label.pages.search"
                  >
                    <b-icon icon="search" />
                  </b-button>
                </b-col>
              </b-row>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-2">
                  <b-col cols="auto" class="px-1" style="padding-top: 7px">
                    <span class="py-1 px-2 bg-ps-second rounded text-white fs9">
                      مجموع شارژ اعتبار کاربران :
                      <strong>
                        {{ totalCharge | localNum }}
                      </strong>
                      ریال
                    </span>
                  </b-col>
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-secondary"
                      class="py-1 pb-1"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.reload"
                      @click="reloadData"
                    >
                      <b-icon
                        icon="arrow-repeat"
                        scale="1.5"
                        color="#fff"
                      ></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #status="{ data }">
              <div>
                <p
                  class="w-100 mb-0 rounded text-white bg-ps-success"
                  v-if="data.data.type === 1"
                >
                  {{ data.data.statusTitle }}
                </p>
                <p
                  class="w-100 mb-0 rounded text-white bg-secondary"
                  v-if="data.data.type === 2"
                >
                  {{ data.data.statusTitle }}
                </p>
              </div>
            </template>
            <DxSummary>
              <DxTotalItem
                column="id"
                summary-type="count"
                alignment="center"
              />
              <DxTotalItem
                column="price"
                summary-type="sum"
                value-format="#,##0.###"
              />
              <DxTotalItem
                column="discountPrice"
                summary-type="sum"
                value-format="#,##0.###"
              />
              <DxTotalItem
                column="finalPrice"
                summary-type="sum"
                value-format="#,##0.###"
              />
            </DxSummary>
            <DxSorting mode="multiple" />
            <DxLoadPanel :enabled="true" />
            <DxScrolling mode="virtual" />
            <DxStateStoring
              :enabled="true"
              type="localStorage"
              storage-key="adminUsersTransactionsList"
            />
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { dataGridMixin } from "@/components/dataGrid/dataGridMixin";
import label from "@/plugins/StaticLabels.js";
import moment from "moment-jalaali";
const startMonth = moment().startOf("jM").format("jYYYY/jMM/jDD");
const endMonth = moment().endOf("jM").format("jYYYY/jMM/jDD");

export default {
  name: "UsersTransactions",
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      fromDateLocal: startMonth,
      toDateLocal: endMonth,
      fields: [
        {
          dataField: "id",
          caption: "کد تراکنش",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          cellTemplate: "status",
          caption: "نوع تراکنش",
          allowSorting: false,
          allowFiltering: false,
          width: "100px",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "price",
          caption: "مبلغ (ریال)",
          dataType: "number",
          format: "#,##0.###",
          cssClass: "text-center align-middle fw2",
          with: "200px",
        },
        {
          dataField: "discountPrice",
          caption: "مبلغ تخفیف(ریال)",
          dataType: "number",
          format: "#,##0.###",
          cssClass: "text-center align-middle fw2",
          with: "200px",
        },
        {
          dataField: "finalPrice",
          caption: "مبلغ نهایی(ریال)",
          dataType: "number",
          format: "#,##0.###",
          cssClass: "text-center align-middle fw2",
          with: "200px",
        },
        {
          dataField: "description",
          caption: "شرح",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "referenceId",
          caption: "کد رهگیری",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "createdLocal",
          caption: "تاریخ",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "userFullName",
          caption: "نام کاربر",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
        {
          dataField: "userId",
          caption: "شناسه کاربر",
          dataType: "string",
          cssClass: "text-center align-middle",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      items: "operationX/transactions",
      totalCharge: "reportX/totalWalletCharge",
    }),
  },
  methods: {
    reloadData() {
      const payload = {
        fromDate: this.fromDateLocal,
        toDate: this.toDateLocal,
      };
      this.$store.dispatch("operationX/getTransactions", payload);
    },
  },
  mounted() {
    this.reloadData();
    this.$store.dispatch("reportX/getTotalWalletCharge");
  },
};
</script>
